import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, NavLink, useLocation, useParams, useSearchParams } from 'react-router-dom';
import { getAdminLoginUser, getMABAA030 } from '../../services/Api';
import { DOMAIN_USER } from '../constants/app';

const Sidebar = () => {
    const [data, setData] = useState({});
    const { id: urlId } = useParams();
    const memberInfoSeq = useSelector(({ member }) => member.memberInfo.seq);
    const id = urlId || memberInfoSeq;

    const { pathname } = useLocation();
    const pathKey = pathname.split('/')[1].split('-')[0];
    const [searchParams] = useSearchParams();
    const tbl = searchParams.get('tbl');
    const memberGbn = searchParams.get('gbn');
    const isPopup = searchParams.get('popup');

    const getMemberStatus = (status) => {
        switch (status) {
            case 'ACT':
                return '활성';
            case 'SLP':
                return '휴면';
            case 'BLOCK':
                return '차단';
            default:
                return '';
        }
    };

    useEffect(() => {
        if (tbl !== null && memberGbn !== null) {
            const fetchData = async () => {
                try {
                    const response = await getMABAA030(id, tbl, memberGbn);
                    setData(response.data.member);
                } catch (error) {
                    console.log(error);
                }
            };
            fetchData();
        }
    }, [id, pathKey, memberGbn, tbl]);

    const handleOpenUser = async (e) => {
        e.preventDefault();
        const adminResponse = await getAdminLoginUser({ params: { memberID: data.memberID } });
        const url = DOMAIN_USER + '/auth-redirect?token=' + adminResponse.data;
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    // const checkPathKey = ['mabaa031','MABAA070','MABAA080','MABAA090','MABAA0100','MABAA0110','MABAA0120','MABAA061']
    return (
        <div className="profile-sidebar">
            <div className="profile-user">
                <div className="profile-user-img">
                    <img src="./images/icons/user.png" alt="icon-user" />
                </div>
                <div className="profile-user-name">{data?.nameKor}</div>
                <div className="profile-user-position">({data?.memberGbn === 'P' ? '개인회원' : '치과회원'})</div>
                <div className="group-profile-button">
                    <div className="group-profile-button-top">
                        <span>{getMemberStatus(data?.memberStatus)}</span>
                    </div>
                    <div className="group-profile-button-bottom">
                        <Link onClick={handleOpenUser}>잡로그인</Link>
                    </div>
                </div>
            </div>
            {pathKey === 'mabaa031' && (
                <ul>
                    <li>
                        <NavLink to={`/mabaa031-${data.seq}?tbl=GM&gbn=P`}>
                            <i className="icon icon-user-profile" />
                            회원 기본정보
                        </NavLink>
                    </li>
                </ul>
            )}
            {pathKey !== 'mabaa031' && data?.memberGbn === 'P' && (
                <ul>
                    <li>
                        <NavLink
                            to={`/${isPopup === 'Y' ? 'mabaa032' : 'mabaa030'}-${data.seq}?tbl=GM&gbn=P${isPopup === 'Y' ? '&popup=Y' : ''
                                }`}
                        >
                            <i className="icon icon-user-profile" />
                            회원 기본정보
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to={`/${isPopup === 'Y' ? 'mabaa042' : 'mabaa040'}-${data.seq}?tbl=GM&gbn=P${isPopup === 'Y' ? '&popup=Y' : ''
                                }`}
                        >
                            <i className="icon icon-bag" />
                            이력서 정보
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to={`/${isPopup === 'Y' ? 'mabaa063' : 'mabaa060'}-${data.seq}?tbl=GM&gbn=P${isPopup === 'Y' ? '&popup=Y' : ''
                                }`}
                        >
                            <i className="icon icon-list" />
                            지원 내역
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to={`/${isPopup === 'Y' ? 'mabaa064' : 'mabaa061'}-${data.seq}?tbl=GM&gbn=P${isPopup === 'Y' ? '&popup=Y' : ''
                                }`}
                        >
                            <i className="icon icon-file" />
                            활동 내역
                        </NavLink>
                    </li>
                </ul>
            )}
            {pathKey !== 'mabaa031' && data?.memberGbn === 'C' && (
                <ul>
                    <li>
                        <NavLink
                            to={`/${isPopup === 'Y' ? 'mabaa072' : 'mabaa070'}-${data.seq}?tbl=GM&gbn=C${isPopup === 'Y' ? '&popup=Y' : ''
                                }`}
                        >
                            <i className="icon icon-user-profile" />
                            회원 기본정보
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to={`/${isPopup === 'Y' ? 'mabaa082' : 'mabaa080'}-${data.seq}?tbl=GM&gbn=C${isPopup === 'Y' ? '&popup=Y' : ''
                                }`}
                        >
                            <i className="icon icon-bag" />
                            채용광고 내역
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to={`/${isPopup === 'Y' ? 'mabaa092' : 'mabaa090'}-${data.seq}?tbl=GM&gbn=C${isPopup === 'Y' ? '&popup=Y' : ''
                                }`}
                        >
                            <i className="icon icon-list" />
                            배너 등록 내역
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to={`/${isPopup === 'Y' ? 'mabaa102' : 'mabaa100'}-${data.seq}?tbl=GM&gbn=C${isPopup === 'Y' ? '&popup=Y' : ''
                                }`}
                        >
                            <i className="icon icon-file" />
                            채용공고 등록 내역
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to={`/${isPopup === 'Y' ? 'mabaa112' : 'mabaa110'}-${data.seq}?tbl=GM&gbn=C${isPopup === 'Y' ? '&popup=Y' : ''
                                }`}
                        >
                            <i className="icon icon-file" />
                            결제 및 증빙 내역
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to={`/${isPopup === 'Y' ? 'mabaa122' : 'mabaa120'}-${data.seq}?tbl=GM&gbn=C${isPopup === 'Y' ? '&popup=Y' : ''
                                }`}
                        >
                            <i className="icon icon-file" />
                            덴탈잡 이용권 내역
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to={`/${isPopup === 'Y' ? 'mabaa062' : 'mabaa061'}-${data.seq}?tbl=GM&gbn=C${isPopup === 'Y' ? '&popup=Y' : ''
                                }`}
                        >
                            <i className="icon icon-file" />
                            활동 내역
                        </NavLink>
                    </li>
                </ul>
            )}
        </div>
    );
};

export default Sidebar;
